<template>
    <a :href="item.url" class="bg-white shadow-md block h-full">
        <div class="bg-cover bg-center aspect-w-16 aspect-h-10" :style="styleCss(item.image)"></div>
        <div class="pt-8 pb-12 px-8">
            <div class="text-sm text-gray mb-4">{{ date }}</div>
            <div class="text-2xl font-serif font-bold text-blue leading-tight">{{ item.title }}</div>
        </div>
     </a>
</template>

<script>
import dayjs from 'dayjs'

export default {

    props: {
        'item': Object
    },

    computed: {
        date() {
            return dayjs(this.item.date).format('DD/MM/YY')
        }
    },

    methods: {
        styleCss(image) {
            let style = 'background-image: url("'+image.small+'");'
            if (image.focus_css) {
                style += 'background-position: '+image.focus_css+';'
            }
            return style
        }
    }

};
</script>